// Simple notification utility
class Notification {
  static initialized = false;

  static init() {
    if (this.initialized) return;

    // Add show class style dynamically
    const style = document.createElement('style');
    style.textContent = `
      .notification.show {
        opacity: 1 !important;
        transform: translateY(0) !important;
      }
    `;
    document.head.appendChild(style);
    this.initialized = true;
  }

  static show(message, type = 'error', duration = 3000) {
    this.init();

    const container = this.getOrCreateContainer();
    const notification = this.createNotification(message, type);

    container.appendChild(notification);

    // Trigger animation
    setTimeout(() => notification.classList.add('show'), 10);

    // Auto remove
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    }, duration);
  }

  static error(message, duration) {
    this.show(message, 'error', duration);
  }

  static success(message, duration) {
    this.show(message, 'success', duration);
  }

  static getOrCreateContainer() {
    let container = document.getElementById('notification-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'notification-container';
      container.style.cssText = `
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10000;
        display: flex;
        flex-direction: column;
        gap: 10px;
        pointer-events: none;
      `;
      document.body.appendChild(container);
    }
    return container;
  }

  static createNotification(message, type) {
    const notification = document.createElement('div');
    const bgColor = type === 'error' ? '#ff4d4f' : '#52c41a';

    notification.style.cssText = `
      background: ${bgColor};
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      max-width: 400px;
      min-width: 200px;
      word-wrap: break-word;
      opacity: 0;
      transform: translateY(-20px);
      transition: all 0.3s ease;
      font-size: 14px;
      line-height: 1.5;
      pointer-events: auto;
      text-align: center;
    `;

    notification.textContent = message;
    notification.classList.add('notification');

    return notification;
  }
}

export default Notification;
